/**
 * @description [自动高度]
 * @date  2017/11/22
 */
export default function autoHeight() {
    return {
        restrict: 'A',
        scope: {
            config: '=',
        },
        link(scope, element) {
            const _config = scope.config
            const winowHeight = $(window).height() // 获取窗口高度
            const { headerHeight } = _config
            const { footerHeight } = _config
            element.css('min-height', `${winowHeight - headerHeight - footerHeight}px`)
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/autoHeight/autoHeightDirective.js